import getFilenameFromDisposition from './getFilenameFromDisposition';

// ----------------------------------------------------------------------------

export type TypeGetFileInfoReturn = { filename?: string; mimetype?: string };

// ----------------------------------------------------------------------------

export function getFileInfoFromResponse(response: Response): TypeGetFileInfoReturn {
    const disposition = response.headers.get('Content-Disposition');
    const contentType = response.headers.get('Content-Type') ?? undefined;

    const filename = getFilenameFromDisposition(disposition);

    return { filename, mimetype: contentType };
}

// ----------------------------------------------------------------------------

export default getFileInfoFromResponse;
